import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CalculatorState {
  eyeStyle: 'happy' | 'focused' | 'sleepy';
  mouthStyle: 'smile' | 'determined' | 'surprised';
  accessory: 'none' | 'bowtie' | 'glasses' | 'hat';
  emotion: 'neutral' | 'excited' | 'concerned' | 'proud';
  setEyeStyle: (style: CalculatorState['eyeStyle']) => void;
  setMouthStyle: (style: CalculatorState['mouthStyle']) => void;
  setAccessory: (accessory: CalculatorState['accessory']) => void;
  setEmotion: (emotion: CalculatorState['emotion']) => void;
}

export const useCalculatorStore = create<CalculatorState>()(
  persist(
    (set) => ({
      eyeStyle: 'happy',
      mouthStyle: 'smile',
      accessory: 'none',
      emotion: 'neutral',
      setEyeStyle: (style) => set({ eyeStyle: style }),
      setMouthStyle: (style) => set({ mouthStyle: style }),
      setAccessory: (accessory) => set({ accessory: accessory }),
      setEmotion: (emotion) => set({ emotion: emotion })
    }),
    {
      name: 'calculator-customization'
    }
  )
);